module.exports = {"620981002":"新市区街道","620981101":"玉门镇","620981102":"赤金镇","620981103":"花海镇","620981104":"老君庙镇","620981105":"黄闸湾镇","620981106":"下西号镇","620981107":"柳河镇","620981108":"昌马镇","620981109":"柳湖镇","620981110":"六墩镇","620981206":"小金湾东乡族乡","620981208":"独山子东乡族乡","620981400":"国营饮马农场","620981401":"国营黄花农场","620981404":"甘肃矿区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620981.json
// module id = 3076
// module chunks = 0